import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';

import localUtil from '../../lib/util';

@observer
class CoffeeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterCountry: '',
            filterProcess: '',
        };
    }

    componentDidMount() {
        this.loadCoffees();
    }

    loadCoffees = async () => {
        const { coffeeStore } = this.props.stores;
        await coffeeStore.load({});
    }

    viewCoffee = (e, props) => {
        const { id } = props ? props : e.target.closest('.box-line').dataset;
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMediumLarge } = appState;

        appState.openDrawer('viewCoffee', {
            id,
            height: drawerHeightMediumLarge,
            callback: () => {
                this.loadCoffees();
            },
        }, drawerLevel + 1);
    }

    addCoffee = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        const { drawerHeightMediumLarge } = appState;

        appState.openDrawer('addCoffee', {
            height: drawerHeightMediumLarge,
            callback: () => {
                this.loadCoffees();
            },
        }, drawerLevel + 1);
    }

    parsePeriod = (period) => {
        if (!period) return 0;
        const months = {
            'january': 1, 'february': 2, 'march': 3, 'april': 4,
            'may': 5, 'june': 6, 'july': 7, 'august': 8,
            'september': 9, 'october': 10, 'november': 11, 'december': 12,
            'januar': 1, 'februar': 2, 'mars': 3, 'april': 4,
            'mai': 5, 'juni': 6, 'juli': 7, 'august': 8,
            'september': 9, 'oktober': 10, 'november': 11, 'desember': 12,
        };
        const parts = period.toLowerCase().split(' ');
        const month = months[parts[0]] || 0;
        const year = parseInt(parts[1], 10) || 0;
        return year * 100 + month;
    }

    render() {
        const { appState, coffeeStore } = this.props.stores;
        const { coffees = [] } = coffeeStore;

        // Use backend sort order (by createdDate, newest first)
        const sortedCoffees = coffees;

        const { classNames = '', maxHeight = '70vh' } = this.props;

        return (
            <div class={`coffee-list ${classNames}`}>
                <div class='d-flex justify-content-between align-items-center mb-3'>
                    <h4 class='mb-0'>
                        <i class='fa-solid fa-coffee me-2' />
                        Coffee Collection
                    </h4>
                    <button
                        class='btn btn-primary btn-sm'
                        onClick={this.addCoffee}
                    >
                        <i class='fa-solid fa-plus me-1' />
                        Add Coffee
                    </button>
                </div>

                {coffees.length === 0 ? (
                    <div class='text-center text-muted py-5'>
                        <i class='fa-solid fa-coffee fa-3x mb-3' />
                        <p>No coffees in your collection yet.</p>
                        <button class='btn btn-primary' onClick={this.addCoffee}>
                            Add Your First Coffee
                        </button>
                    </div>
                ) : (
                    <div class='row g-3' style={`max-height: ${maxHeight}; overflow-y: auto;`}>
                        {sortedCoffees.map(coffee => {
                            const image = coffee.images?.[0];
                            const imageUrl = image?.s3MediumLink || image?.s3Link;
                            return (
                                <div class='col-12 col-md-6 col-lg-4' key={coffee.id}>
                                    <div
                                        class='card h-100 shadow-sm'
                                        style='cursor: pointer;'
                                        onClick={() => this.viewCoffee(null, { id: coffee.id })}
                                    >
                                        {imageUrl && (
                                            <img
                                                src={imageUrl}
                                                class='card-img-top'
                                                style='height: 140px; object-fit: cover;'
                                                alt={coffee.name}
                                            />
                                        )}
                                        <div class='card-body p-2'>
                                            <div class='d-flex justify-content-between align-items-start mb-1'>
                                                <h6 class='card-title mb-0 flex-grow-1'>{coffee.name}</h6>
                                                <div class='d-flex gap-1'>
                                                    {coffee.cuppingScore && (
                                                        <span class='badge bg-info' title='Cupping Score'>
                                                            {coffee.cuppingScore}
                                                        </span>
                                                    )}
                                                    <span class={`badge ${coffee.score ? 'bg-warning text-dark' : 'bg-secondary'}`} title='Your Rating'>
                                                        {coffee.score ? `${coffee.score}/10` : '-'}
                                                    </span>
                                                </div>
                                            </div>
                                            {coffee.period && (
                                                <div class='small text-muted mb-1'>
                                                    <i class='fa-solid fa-box me-1 text-success' />
                                                    {coffee.period}
                                                </div>
                                            )}
                                            <div class='row small text-muted'>
                                                <div class='col-6'>
                                                    <i class='fa-solid fa-globe me-1 text-primary' />
                                                    {coffee.country}
                                                    {coffee.location && <span class='opacity-75'> · {coffee.location}</span>}
                                                </div>
                                                {coffee.roastery && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-fire me-1 text-danger' />
                                                        {coffee.roastery}
                                                    </div>
                                                )}
                                            </div>
                                            <div class='row small text-muted'>
                                                {coffee.producer && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-user me-1 text-success' />
                                                        {coffee.producer}
                                                    </div>
                                                )}
                                                {coffee.variety && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-seedling me-1 text-success' />
                                                        {coffee.variety}
                                                    </div>
                                                )}
                                            </div>
                                            <div class='row small text-muted'>
                                                {coffee.process && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-flask me-1 text-info' />
                                                        {coffee.process}
                                                    </div>
                                                )}
                                                {coffee.altitude && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-mountain me-1 text-secondary' />
                                                        {coffee.altitude} masl
                                                    </div>
                                                )}
                                            </div>
                                            <div class='row small text-muted'>
                                                {coffee.harvest && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-calendar-days me-1 text-primary' />
                                                        Harvest: {coffee.harvest}
                                                    </div>
                                                )}
                                                {coffee.roasterMachine && (
                                                    <div class='col-6'>
                                                        <i class='fa-solid fa-gear me-1 text-secondary' />
                                                        {coffee.roasterMachine}
                                                    </div>
                                                )}
                                            </div>
                                            {coffee.flavor && (
                                                <div class='small text-warning mt-1'>
                                                    <i class='fa-solid fa-lemon me-1' />
                                                    {coffee.flavor}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

export default CoffeeList;
